export type PdfAttachment = {
  name: string;
  blob: Blob;
};

/**
 * Extracts base64-embedded PDFs from an XML document (e.g. UBL invoices):
 * `<cbc:EmbeddedDocumentBinaryObject mimeCode="application/pdf" filename="X.PDF">`
 */
export function extractPdfAttachments(xml: string): PdfAttachment[] {
  const doc = new DOMParser().parseFromString(xml, 'application/xml');

  if (doc.getElementsByTagName('parsererror').length) {
    throw new Error('Invalid XML');
  }

  return Array.from(
    doc.getElementsByTagNameNS('*', 'EmbeddedDocumentBinaryObject'),
  )
    .filter(
      (element) =>
        element.getAttribute('mimeCode')?.toLowerCase() === 'application/pdf',
    )
    .map((element, idx) => {
      const binary = atob((element.textContent ?? '').replace(/\s/g, ''));
      const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));

      return {
        name: element.getAttribute('filename') || `attachment-${idx + 1}.pdf`,
        blob: new Blob([bytes], { type: 'application/pdf' }),
      };
    });
}
